// app/javascript/controllers/order_items_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template"]

  add(event) {
    event.preventDefault()

    const html = this.templateTarget.innerHTML.replaceAll(
      "NEW_RECORD",
      Date.now()
    )

    this.containerTarget.insertAdjacentHTML("beforeend", html)
  }

  remove(event) {
    event.preventDefault()

    const row = event.target.closest(".nested-fields")
    const destroy = row.querySelector("input[name*='_destroy']")

    if (destroy) {
      destroy.value = 1
      row.style.display = "none"
    } else {
      row.remove()
    }

    document.dispatchEvent(new CustomEvent("offer:recalculate", { bubbles: true }))
  }
}
